import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getAllCustomers } from "../../api";
import "./ManageCustomer.css";

const ManageCustomer = () => {
  const [customers, setCustomers] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchCustomers = async () => {
      try {
        const response = await getAllCustomers();
        const filteredCustomers = response.data.filter(
          (customer) => customer.product_sku !== "Stringing Service"
        );
        setCustomers(filteredCustomers);
      } catch (error) {
        console.error("Error fetching customers:", error);
      }
    };

    fetchCustomers();
  }, []);

  const handleBackClick = () => {
    navigate(-1);
  };

  const handleViewDetailsClick = (customer) => {
    navigate("/admin/dashboard/customer-details", { state: { customer } });
  };

  return (
    <div className="manage-customer">
      <h2>Manage Customers</h2>
      <table className="customer-table">
        <thead>
          <tr>
            <th>Customer Name</th>
            <th>Invoice No</th>
            <th>Purchase Date</th>
            <th>Invoice Total</th>
            <th>Valid Until</th>
            <th>Product SKU</th>
            <th>View</th>
          </tr>
        </thead>
        <tbody>
          {customers.map((customer) => (
            <tr key={customer.invoice_no}>
              <td>{`${customer.first_name} ${customer.last_name}`}</td>
              <td>{customer.invoice_no}</td>
              <td>{new Date(customer.purchase_date).toLocaleDateString()}</td>
              <td>{customer.invoice_total}</td>
              <td>{new Date(customer.valid_until).toLocaleDateString()}</td>
              <td>{customer.product_sku}</td>
              <td>
                <button
                  className="view-details-button"
                  onClick={() => handleViewDetailsClick(customer)}
                >
                  View Details
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <button className="back-button" onClick={handleBackClick}>
        Back
      </button>
    </div>
  );
};

export default ManageCustomer;
